import createCache from '@emotion/cache';

// Create a new cache instance
const emotionCache = createCache({
  key: 'css',
  prepend: true,
  speedy: false
});

export default emotionCache; 